import { render, staticRenderFns } from "./TrainingItemSingleNav.vue?vue&type=template&id=3b7468ba&"
import script from "./TrainingItemSingleNav.vue?vue&type=script&lang=js&"
export * from "./TrainingItemSingleNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports